import { render, staticRenderFns } from "./chooseWorkspaceUser.vue?vue&type=template&id=25335c29"
import script from "./chooseWorkspaceUser.vue?vue&type=script&lang=js"
export * from "./chooseWorkspaceUser.vue?vue&type=script&lang=js"
import style0 from "./chooseWorkspaceUser.vue?vue&type=style&index=0&id=25335c29&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports